import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0, 3, 3, 3),
    display: "flex",
    flexWrap: "wrap",
  },

  card: {
    display: "flex",
    flexDirection: "column",
    height: "100%", // Asegura que todas las tarjetas tengan el mismo tamaño
    border: "3px solid #ccc",
    borderRadius: "15px", // Bordes redondeados
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)", // Sombra suave para mejorar el aspecto
    overflow: "hidden", // Evita que el contenido se desborde
    transition: "box-shadow 0.3s ease-in-out",
    "&:hover": {
      boxShadow: "0 15px 30px rgba(0, 0, 0, 0.3)",
      borderColor: "#999",
    },
  },
  cardMedia: {
    height: 140,
    objectFit: "cover", // Asegura que la imagen cubra el área del contenedor
    borderTopLeftRadius: "15px", // Bordes redondeados en la esquina superior izquierda
    borderTopRightRadius: "15px",
    backgroundSize: "cover", // Bordes redondeados en la esquina superior derecha
  },
  cardContent: {
    flexGrow: 1, // Permite que el contenido ocupe el espacio restante
    padding: theme.spacing(2),
  },
  cardTitle: {
    fontSize: "1.5rem", // Aumentar el tamaño del título
    color: theme.palette.primary.main, // Color del título
    textAlign: "center", // Centrar el texto
    marginBottom: theme.spacing(2), // Espacio adicional debajo del título
  },
  cardDescription: {
    fontSize: "1rem", // Tamaño de la descripción
    color: "#666", // Color de la descripción
    textAlign: "left", // Justificar el texto
    marginTop: theme.spacing(2), // Espacio adicional arriba de la descripción
  },
  pageName: {
    paddingTop: theme.spacing(3),
    font: "var(--unnamed-font-style-normal) normal bold 30px/34px var(--unnamed-font-family-arial)",
    letterSpacing: "var(--unnamed-character-spacing-0)",
    color: "var(--unnamed-color-ffffff)",
    opacity: 1,
    textAlign: "justify",
  },
  link: {
    color: "var(--unnamed-color-ffffff)",
    textDecoration: "none",
  },
  titulo: {
    letterSpacing: "var(--unnamed-character-spacing-0)",
    color: "#051e34",
    textAlign: "justify",
    fontSize: "4vh",
    fontWeight: "bold",
    opacity: 1,
    margin: "30px",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  subtituloCon: {
    paddingTop: theme.spacing(4),
    letterSpacing: "var(--unnamed-character-spacing-0)",
    color: "#ff4957",
    padding: "0px 15px",
    fontSize: "3vh",
    fontWeight: "bold",
    opacity: 1,
    margin: "30px",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  media: {
    height: 140,
    objectFit: "cover",
  },
  subtituloSin: {
    paddingTop: theme.spacing(3),
    letterSpacing: "var(--unnamed-character-spacing-0)",
    color: "#00a9db",
    padding: "0px 15px",
    fontSize: "3vh",
    fontWeight: "bold",
    opacity: 1,
    margin: "30px",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  table: {
    minWidth: "100%",
  },
  calendarIcon: {
    marginBottom: "20px",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  bar: {
    backgroundColor: theme.palette.primary.main, // Color azul para el AppBar
    zIndex: 0,
  },
  tab: {
    color: "white", // Color blanco para las letras
  },
  indicator: {
    backgroundColor: "#2E86C1",
    height: 6, // Color del indicador de la pestaña activa
  },
}));
export default useStyles;
